// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeGenerateManagement_main__iemQO {
    position: relative;
    width: 100%;
    height: 100%;
}

.CategorizeGenerateManagement_header__3RBgQ {
    display: flex;
    justify-content: space-between;
    height: 35px;
    margin-bottom: 25px;
}

.CategorizeGenerateManagement_title__CjBwh {
    font-size: 30px;
}

.CategorizeGenerateManagement_container__iBHgs {
    width: 100%;
    height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.CategorizeGenerateManagement_container_top__ldmIh {
    width: 100%;
    height: 40%;
}

.CategorizeGenerateManagement_container_bottom__5z5n4 {
    width: 100%;
    height: 60%;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeGenerateManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;AACf","sourcesContent":[".main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    width: 100%;\n    height: calc(100% - 60px);\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.container_top {\n    width: 100%;\n    height: 40%;\n}\n\n.container_bottom {\n    width: 100%;\n    height: 60%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeGenerateManagement_main__iemQO`,
	"header": `CategorizeGenerateManagement_header__3RBgQ`,
	"title": `CategorizeGenerateManagement_title__CjBwh`,
	"container": `CategorizeGenerateManagement_container__iBHgs`,
	"container_top": `CategorizeGenerateManagement_container_top__ldmIh`,
	"container_bottom": `CategorizeGenerateManagement_container_bottom__5z5n4`
};
export default ___CSS_LOADER_EXPORT___;
